import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, EntiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useEntiDataSource() {
    const api = new EntiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getEnti({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getEnteById({
                tenantId: currentTenant.Id,
                enteId: key
            });
          },
    
          insert: (values) => {
            return api.insertEnte({
                tenantId: currentTenant.Id,
                enteCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateEnte ({
                tenantId: currentTenant.Id,
                enteId: key,
                enteUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteEnte({
                tenantId: currentTenant.Id,
                enteId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


